import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * 빈 상태 공통 컴포넌트
 *
 * 데이터가 없을 때 아이콘 + 제목 + 설명을 표시합니다.
 * - dashed: 점선 테두리 스타일 (업로드 영역 등)
 * - plain: 단순 텍스트 스타일 (카드 내부 등)
 */

export interface AppEmptyStateProps {
  /** lucide 아이콘 컴포넌트 */
  icon: LucideIcon;
  /** 주요 메시지 */
  title: string;
  /** 보조 설명 */
  description?: string;
  /** 스타일 변형 */
  variant?: 'dashed' | 'plain';
  /** 추가 className */
  className?: string;
}

export function AppEmptyState({
  icon: Icon,
  title,
  description,
  variant = 'plain',
  className,
}: AppEmptyStateProps) {
  const isDashed = variant === 'dashed';

  return (
    <div
      className={cn(
        'text-center',
        isDashed
          ? 'py-12 border-2 border-dashed border-neutral-200 rounded-lg'
          : 'py-8 text-neutral-500',
        className
      )}
    >
      <Icon
        className={cn(
          'mx-auto mb-3',
          isDashed ? 'w-10 h-10 text-neutral-400' : 'w-12 h-12 text-neutral-300'
        )}
      />
      <p className={isDashed ? 'text-neutral-600 mb-2' : undefined}>
        {title}
      </p>
      {description && (
        <p className={cn('text-sm', isDashed ? 'text-neutral-500' : 'mt-1')}>
          {description}
        </p>
      )}
    </div>
  );
}
